module.exports = __webpack_public_path__ + "assets/19de8fa081b13c1bdafbb2c8227989db.png";